<template>
    <div class="pre-login-btn">
        <img src="../assets/images/home/prelogin.png" alt="">
    </div>
</template>

<script>
export default {
    name: "pre-login",

    components: {

    },
    data: () => ({
    }),
    created() {

    },
    mounted() {

    },
    watch: {

    },
    computed: {

    },
    methods: {

    },
};
</script>

<style lang="scss" scoped>
.pre-login-btn {
    position: absolute;
    z-index: 3;
    width: pxTorem(80px);
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    display: none;

    img {
        width: 100%;
    }

    &::after {
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        background: url("../assets/images/home/prelogin_actived.png") no-repeat center;
        background-size: 100%;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
        transition: opacity, .3s;
    }
    &:hover::after {
        opacity: 1;
    }
}
</style>
